import React from 'react';

// react-i18next.d.ts
declare module 'react-i18next';

type ReactI18NextChildren = React.ReactNode | ObjectOrNever;

declare module 'react' {
  declare module '*.png';
  declare module '*.jpg';
  declare module '*.ttf';
  declare module '*.svg';
  declare module '*.css';
  declare module '*.json';
  declare module 'googlemaps';
  interface HTMLAttributes {
    children?: ReactI18NextChildren | ReactI18NextChildren[];
  }
}

declare global {
  interface String {
    eqIgnoreConvention(str: string): boolean;
  }
}

// Compares two strings ignoring naming conventions e.g. snake_case, camelCase, etc.
String.prototype.eqIgnoreConvention = function (str: string): boolean {
  return (
    this.replace(/[_-]/g, '').toLowerCase() ===
    str.replace(/[_-]/g, '').toLowerCase()
  );
};
